/*
 * Preview the media for a partially selected product variant.
 *
 * The core picker intentionally leaves the variant incomplete until every
 * option is chosen. This companion keeps that behaviour for add-to-cart, but
 * lets a visitor see the image attached to the option they just selected.
 */
(() => {
  const install = () => {
    const Picker = customElements.get('variant-picker');
    if (!Picker || !Picker.prototype || Picker.prototype.__teseryPartialMediaPreview) return;

    const proto = Picker.prototype;
    const originalOnVariantChange = proto.onVariantChange;
    const originalUpdateMedia = proto.updateMedia;

    proto.getPartialVariant = function () {
      const options = this.options || [];
      if (!options.some(Boolean)) return undefined;

      return this.productData?.variants?.find((variant) =>
        options.every((option, index) => !option || variant.options[index] === option)
      );
    };

    proto.updatePartialMedia = function () {
      const partialVariant = this.getPartialVariant();
      if (!partialVariant) return;

      this.getDataImageVariant(partialVariant.id);

      // Reuse the theme's existing gallery filtering for variant-image groups.
      // Temporarily supplying the preview variant does not select it for cart
      // or URL state; the picker still remains incomplete until all options
      // are chosen.
      const previousVariant = this.currentVariant;
      this.currentVariant = partialVariant;
      try {
        originalUpdateMedia.call(this);
      } finally {
        this.currentVariant = previousVariant;
      }
    };

    proto.onVariantChange = function (event) {
      originalOnVariantChange.call(this, event);
      if (!this.currentVariant && this.options?.some(Boolean)) {
        this.updatePartialMedia();
      }
    };

    proto.__teseryPartialMediaPreview = true;
  };

  if (customElements.get('variant-picker')) {
    install();
  } else {
    customElements.whenDefined('variant-picker').then(install);
  }
})();
